@file:Suppress("EXPECT_ACTUAL_CLASSIFIERS_ARE_IN_BETA_WARNING")

package com.wintermar.inspection.feature.domain.service

import com.wintermar.inspection.core.domain.FlowResult
import com.wintermar.inspection.core.domain.Result
import com.wintermar.inspection.feature.domain.repository.answer.AnswerRepository
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.launch
import org.koin.core.component.KoinComponent
import org.koin.core.component.inject

actual class SubmitRetryService actual constructor() : KoinComponent {

    private val answerRepository: AnswerRepository by inject()
    private val scope = CoroutineScope(Dispatchers.Default + SupervisorJob())
    private var job: Job? = null
    private var isRunning = false

    actual fun trigger() {
        if (isRunning) return  // already running, skip
        job?.cancel()
        job = scope.launch {
            isRunning = true
            try {
                val failedResult = answerRepository.getFailedSubmit()
                if (failedResult !is Result.Success) return@launch
                failedResult.data?.forEach { (answer, answerType) ->
                    answerRepository.submitAnswer(answer, answerType).collect { result ->
                        if (result is FlowResult.Success) {
                            answerRepository.insertAnswer(answer.copy(isSubmitted = true))
                        }
                    }
                }
            } finally {
                // Always reset flag — even if cancelled, trigger() can restart
                isRunning = false
            }
        }
    }

    actual fun cancel() {
        // Cancel job only — isRunning resets via finally, scope stays alive
        job?.cancel()
        job = null
    }
}
